export default __webpack_public_path__ + "static/media/1213 utensils side.26ed5228.png";